import {
  DailyLogOperationInstance,
  DailyOperationLogRecord
} from '../projects/operation.models';
import { SetupChangeLogRecord } from '../setup/setup.models';
import {
  WeatherReading,
  WeatherRemarkEditor,
  WeatherSetup
} from '../weather-readings/weather-readings.models';
import { ConsumableEditor } from '../consumables/consumables.models';
import { VesselCrewEditor } from '../vessel-crew/vessel-crew.models';
import { EnumSummary } from '../base/base.model';
import { JackingActivityEditor } from '../projects/jacking-activity.models';
import { DailyObservationEditor } from '../daily-observations/daily-observations';
import { DailyLegLoad } from '../daily-leg-loads/daily-leg-load.models';
import { FieldPositioningEditor } from '../field-positioning/field-positioning.models';
import { TimeZoneChangeEditor } from '../time-zones/time-zone.models';
import { OnSiteMovementEditor } from '../on-site-movement/on-site-movement.models';
import { VoyageLogSummary } from '../voyage-log/voyagelog.models';
import { TransitSaveHelper } from '../transit/transit.models';
import { DateTime } from 'luxon';

export class AppData {
  localId?: number;
  dailyLogDate?: DateTime;
  dailyLogRecords?: DailyOperationLogRecord[] = [];
  dailyLogOperationInstances?: DailyLogOperationInstance[] = [];
  setupChangeLogRecords?: SetupChangeLogRecord[] = [];
  weatherSetups: WeatherSetup[] = [];
  weatherReadingLogRecords: WeatherReading[] = [];
  weatherRemarkEditors: WeatherRemarkEditor[] = [];
  consumables: ConsumableEditor[] = [];
  vesselCrewStats: VesselCrewEditor[] = [];
  dailyObservationStats: DailyObservationEditor[] = [];
  overtimeRequestedBys: EnumSummary[] = [];
  vesselId?: number;
  jackingActivities?: JackingActivityEditor[] = [];
  fieldPositioningEditors?: FieldPositioningEditor[] = [];
  dailyLegLoads: DailyLegLoad[] = [];
  cleanseLogs: boolean;
  transactionId?: number;
  timeZoneChangeEditors: TimeZoneChangeEditor[] = [];
  onSiteMovementRecords: OnSiteMovementEditor[] = [];
  voyageLog: VoyageLogSummary;
  voyageLogRemoved: boolean;
  voyageLogEndRemoved: boolean;
  delaySaveHelpers?: DelaySaveHelper[] = [];
  timerInfo?: string;
  transitSaveHelper: TransitSaveHelper;
}

export class AppDataSummary {
  localId?: number;
  dailyLogRecordIds?: number[] = [];
  dailyLogOperationInstanceIds?: number[] = [];
  setupChangeLogRecordIds?: number[] = [];
  timeZoneChangeId?: number;
  weatherReadingIds?: number[] = [];
  ignoreBatchedSetupChanges: boolean;
  keepComments: boolean;
}

export class DelaySaveHelper {
  dailyLogDate: DateTime;
  vesselId: number;

  delay: DailyLogOperationInstance;
  delayLogRecords: DailyOperationLogRecord[] = [];

  dailyLogIdsToDelete: number[] = [];
  operationIdsToDelete: number[] = [];

  cancelledOperations: DailyLogOperationInstance[] = [];
  pausedOperations: DailyLogOperationInstance[] = [];
  switchedOperations: DailyLogOperationInstance[] = [];
  continuedOperations: DailyLogOperationInstance[] = [];

  affectedOperationDailyLogRecords: DailyOperationLogRecord[] = [];
  setupChangeLogRecords: SetupChangeLogRecord[] = [];

  // used when saving a delay in locked day mode
  localWeatherReadings: WeatherReading[] = [];

  pauseTimeIdsToDelete: number[] = [];
}

export class OperationInstanceSaveRequest {
  operationInstanceEditor: DailyLogOperationInstance;
  dailyLogDate: DateTime;

  onSiteMovementEditor?: OnSiteMovementEditor;
  jackingActivityEditor?: JackingActivityEditor;

  // todo check all needed
  voyageLog?: VoyageLogSummary;
  voyageLogRecords?: VoyageLogSummary[] = [];
  voyageLogRemoved?: boolean;
  voyageLogEndRemoved?: boolean;
  delaySaveHelpers?: DelaySaveHelper[] = [];
  timerInfo?: string;
  transitSaveHelper?: TransitSaveHelper;

  newLocationId?: number; // todo remove i think
  transitingSetupChangeRecords?: SetupChangeLogRecord[] = [];
}

export class AppDataFilters {
  date: DateTime;
  vesselId?: number;
  loadLegLoadLogData?: boolean;
  loadWeatherLogData?: boolean;
  loadJackingData?: boolean;
}

export class TypeSwitchDelayLink {
  typeSwitchId: number;
  delayId: number;
}



// WEBPACK FOOTER //
// ./src/models/app-data/app-data.ts